import { render, staticRenderFns } from "./SwitchOnOff.vue?vue&type=template&id=33259dfe&scoped=true&"
import script from "./SwitchOnOff.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SwitchOnOff.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33259dfe",
  null
  
)

export default component.exports